import { Component, inject, input, signal } from '@angular/core';
import { GetRelatedArticlesParam, RelatedArticleItems } from '../../interface/articles';
import { Api } from '../../services/api';
import { catchError, delay, of, take, tap, timeout } from 'rxjs';
import { TruncatePipe } from '../../pipes/truncate-pipe';
import { RouterLink } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-widget-related',
  imports: [
    RouterLink,
    TruncatePipe,
    NgxSkeletonLoaderModule
  ],
  templateUrl: './widget-related.html',
  styleUrl: './widget-related.css',
})
export class WidgetRelated {
  category = input<string>('');
  exclude = input<string>('');
  private api = inject(Api);
  isLoading = signal(false);
  articles = signal<RelatedArticleItems[]>([]);

  private initialize(obj: GetRelatedArticlesParam) : void {
    this.isLoading.set(true);

    this.api.getWidgetRelatedArticles(obj)
    .pipe(
      take(1),
      timeout(10000),
      catchError(() => of([])),
      tap(() => this.isLoading.set(false))
    ).subscribe(arr => {
      this.articles.set(arr);
    });
  }

  ngOnInit() : void {
    this.initialize({
      category: this.category(),
      exclude: this.exclude()
    });
  }
}
